import {
	MIN_BARCODE_LENGTH,
	detectScannerInput,
} from "./barcodeUtils";

export const SCAN_IDLE_MS = 80;
/** Blocks double-fire of the same read (Android wedge); allows re-scan for +qty after. */
export const DUPLICATE_SCAN_MS = 200;
export const HIGHLIGHT_ROW_MS = 2000;

const DEBUG_KEY = "DEBUG_POS_SCAN";

export const isPosScanDebugEnabled = () =>
	typeof localStorage !== "undefined" &&
	localStorage.getItem(DEBUG_KEY) === "1";

/** @param {...unknown} args */
export const posScanLog = (...args) => {
	if (
		process.env.NODE_ENV === "development" ||
		isPosScanDebugEnabled()
	) {
		console.log("[POS-Scan]", ...args);
	}
};

/**
 * Short beep via Web Audio (works on many Android Chrome sessions after user gesture).
 * @param {"success" | "error"} type
 */
export const playPosScanTone = (type = "success") => {
	try {
		const Ctx = window.AudioContext || window.webkitAudioContext;
		if (!Ctx) return;
		const ctx = new Ctx();
		const osc = ctx.createOscillator();
		const gain = ctx.createGain();
		osc.connect(gain);
		gain.connect(ctx.destination);
		osc.frequency.value = type === "success" ? 920 : 280;
		gain.gain.value = 0.4;
		osc.start();
		osc.stop(ctx.currentTime + (type === "success" ? 0.07 : 0.14));
		setTimeout(() => ctx.close?.(), 200);
	} catch {
		// ignore — audio optional
	}
};

/**
 * Decide if idle input should auto-run barcode lookup (not manual product name search).
 * @param {string} value
 * @param {Array<{ at: number, delta: number }>} inputEvents
 * @param {number[]} keyTimes
 * @param {{ force?: boolean }} [options]
 */
export const shouldAutoProcessScan = (value, inputEvents = [], keyTimes = [], options = {}) => {
	const trimmed = String(value || "").trim();
	if (trimmed.length < MIN_BARCODE_LENGTH) return false;
	if (options.force) return true;

	// EAN/UPC-style numeric (Android wedge often dumps full code without Enter)
	if (/^\d{8,}$/.test(trimmed)) return true;

	// Single-shot bulk insert (common on Android / Scandit wedge)
	const bulk = inputEvents.some((e) => e.delta >= 4);
	if (bulk && trimmed.length >= MIN_BARCODE_LENGTH) return true;

	if (inputEvents.length >= 2) {
		const intervals = [];
		for (let i = 1; i < inputEvents.length; i += 1) {
			intervals.push(inputEvents[i].at - inputEvents[i - 1].at);
		}
		const avg = intervals.reduce((s, n) => s + n, 0) / intervals.length;
		if (avg < 55 && trimmed.length >= MIN_BARCODE_LENGTH) return true;
	}

	if (detectScannerInput(keyTimes)) return true;

	return false;
};
